import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '..\\layouts\\error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_pluginutils_6ee1e9ce from 'nuxt_plugin_pluginutils_6ee1e9ce' // Source: .\\nuxt-i18n\\plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_d20d93b8 from 'nuxt_plugin_pluginrouting_d20d93b8' // Source: .\\nuxt-i18n\\plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_261407cb from 'nuxt_plugin_pluginmain_261407cb' // Source: .\\nuxt-i18n\\plugin.main.js (mode: 'all')
import nuxt_plugin_passwordprotect_3453cc86 from 'nuxt_plugin_passwordprotect_3453cc86' // Source: .\\password-protect.js (mode: 'all')
import nuxt_plugin_axios_38f42bf5 from 'nuxt_plugin_axios_38f42bf5' // Source: .\\axios.js (mode: 'all')
import nuxt_plugin_nuxtvuexroutersync_2b6e2a46 from 'nuxt_plugin_nuxtvuexroutersync_2b6e2a46' // Source: .\\nuxt-vuex-router-sync.js (mode: 'all')
import nuxt_plugin_vuewaitplugin_1b8e0fe7 from 'nuxt_plugin_vuewaitplugin_1b8e0fe7' // Source: .\\vue-wait-plugin.js (mode: 'all')
import nuxt_plugin_settings_40e51f80 from 'nuxt_plugin_settings_40e51f80' // Source: .\\settings.js (mode: 'all')
import nuxt_plugin_vuedi_dace9ed2 from 'nuxt_plugin_vuedi_dace9ed2' // Source: .\\vue-di.js (mode: 'all')
import nuxt_plugin_vuexpersistclient_3ecc3cfa from 'nuxt_plugin_vuexpersistclient_3ecc3cfa' // Source: ..\\plugins\\vuex-persist.client.ts (mode: 'client')
import nuxt_plugin_ie_3498324a from 'nuxt_plugin_ie_3498324a' // Source: ..\\plugins\\ie.ts (mode: 'all')
import nuxt_plugin_mobiledetectclient_0c2ae78c from 'nuxt_plugin_mobiledetectclient_0c2ae78c' // Source: ..\\plugins\\mobile-detect.client.ts (mode: 'client')
import nuxt_plugin_components_50cb0ca1 from 'nuxt_plugin_components_50cb0ca1' // Source: ..\\plugins\\components.ts (mode: 'all')
import nuxt_plugin_validation_7d99af44 from 'nuxt_plugin_validation_7d99af44' // Source: ..\\plugins\\validation.ts (mode: 'all')
import nuxt_plugin_rx_3389451e from 'nuxt_plugin_rx_3389451e' // Source: ..\\plugins\\rx.ts (mode: 'all')
import nuxt_plugin_di_35217a5c from 'nuxt_plugin_di_35217a5c' // Source: ..\\plugins\\di.ts (mode: 'all')
import nuxt_plugin_vueclient_dce95d38 from 'nuxt_plugin_vueclient_dce95d38' // Source: ..\\plugins\\vue.client.ts (mode: 'client')
import nuxt_plugin_aiclient_5b87d09c from 'nuxt_plugin_aiclient_5b87d09c' // Source: ..\\plugins\\ai.client.ts (mode: 'client')
import nuxt_plugin_moment_57893b12 from 'nuxt_plugin_moment_57893b12' // Source: ..\\plugins\\moment.ts (mode: 'all')
import nuxt_plugin_vuetifydev_70777e0d from 'nuxt_plugin_vuetifydev_70777e0d' // Source: ..\\plugins\\vuetify-dev.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Coupon Portal","titleTemplate":function (titleChunk) {
                if (process.env.NAME && titleChunk && titleChunk !== process.env.NAME) {
                    return `${titleChunk} :: ${process.env.NAME}`;
                }
                if (process.env.NAME) {
                    return process.env.NAME;
                }
                return titleChunk;
            },"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"'SOTYKTU (deucravacitinib) EConsent Program'"},{"hid":"ie","http-equiv":"x-ua-compatible","content":"IE=edge"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"SOTYKTU (deucravacitinib)"},{"hid":"author","name":"author","content":"TrialCard"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"SOTYKTU (deucravacitinib)"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"SOTYKTU (deucravacitinib)"},{"hid":"og:description","name":"og:description","property":"og:description","content":"'SOTYKTU (deucravacitinib) EConsent Program'"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"favicon.ico"},{"rel":"manifest","href":"#{BasePath}#\u002F_nuxt\u002Fmanifest.d304e814.json"},{"rel":"icon","type":"image\u002Fpng","href":"#{BasePath}#\u002Ficons\u002Ffavicon-96x96.png","sizes":"96x96"},{"rel":"icon","type":"image\u002Fsvg+xml","href":"#{BasePath}#\u002Ficons\u002Ffavicon.svg"},{"rel":"shortcut icon","href":"#{BasePath}#\u002Ficons\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"#{BasePath}#\u002Ficons\u002Fapple-touch-icon.png"}],"style":[],"script":[],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_pluginutils_6ee1e9ce === 'function') {
    await nuxt_plugin_pluginutils_6ee1e9ce(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_d20d93b8 === 'function') {
    await nuxt_plugin_pluginrouting_d20d93b8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_261407cb === 'function') {
    await nuxt_plugin_pluginmain_261407cb(app.context, inject)
  }

  if (typeof nuxt_plugin_passwordprotect_3453cc86 === 'function') {
    await nuxt_plugin_passwordprotect_3453cc86(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_38f42bf5 === 'function') {
    await nuxt_plugin_axios_38f42bf5(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtvuexroutersync_2b6e2a46 === 'function') {
    await nuxt_plugin_nuxtvuexroutersync_2b6e2a46(app.context, inject)
  }

  if (typeof nuxt_plugin_vuewaitplugin_1b8e0fe7 === 'function') {
    await nuxt_plugin_vuewaitplugin_1b8e0fe7(app.context, inject)
  }

  if (typeof nuxt_plugin_settings_40e51f80 === 'function') {
    await nuxt_plugin_settings_40e51f80(app.context, inject)
  }

  if (typeof nuxt_plugin_vuedi_dace9ed2 === 'function') {
    await nuxt_plugin_vuedi_dace9ed2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersistclient_3ecc3cfa === 'function') {
    await nuxt_plugin_vuexpersistclient_3ecc3cfa(app.context, inject)
  }

  if (typeof nuxt_plugin_ie_3498324a === 'function') {
    await nuxt_plugin_ie_3498324a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mobiledetectclient_0c2ae78c === 'function') {
    await nuxt_plugin_mobiledetectclient_0c2ae78c(app.context, inject)
  }

  if (typeof nuxt_plugin_components_50cb0ca1 === 'function') {
    await nuxt_plugin_components_50cb0ca1(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_7d99af44 === 'function') {
    await nuxt_plugin_validation_7d99af44(app.context, inject)
  }

  if (typeof nuxt_plugin_rx_3389451e === 'function') {
    await nuxt_plugin_rx_3389451e(app.context, inject)
  }

  if (typeof nuxt_plugin_di_35217a5c === 'function') {
    await nuxt_plugin_di_35217a5c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclient_dce95d38 === 'function') {
    await nuxt_plugin_vueclient_dce95d38(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aiclient_5b87d09c === 'function') {
    await nuxt_plugin_aiclient_5b87d09c(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_57893b12 === 'function') {
    await nuxt_plugin_moment_57893b12(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetifydev_70777e0d === 'function') {
    await nuxt_plugin_vuetifydev_70777e0d(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
